/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_Plan_ChipInputs */

const en_features_plan_chip = /** @type {(inputs: Features_Plan_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan sent: ${i?.name}`)
};

const pl_features_plan_chip = /** @type {(inputs: Features_Plan_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan wysłany: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Plan sent: {name}" |
*
* @param {Features_Plan_ChipInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_chip = /** @type {((inputs: Features_Plan_ChipInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_ChipInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_chip(inputs)
	return en_features_plan_chip(inputs)
});